import { createContext } from "react"
import Offer from "../Models/Offer"
import PaymentType from "../Models/PaymentType"
import OffersRequest from "../Requests/OffersRequest"
import { OptionSelection } from "../Views/OptionsView/OptionsView"
import PaymentMode from "../Models/PaymentMode"
import OptionProduct from "../Models/OptionProduct"
import { ExtendedPlanPair } from "../Models/Plan"
import Product from "../Models/Product"
import PackageProducts from "../Models/PackageProducts"
import { DocumentType } from "../Enums/DocumentType"
import PlanOption from "../Models/PlanOption"

export interface Configuration extends OffersRequest {
	isCovered: boolean

	customerId?: Number
	contractId?: Number

	zone?: string
	validateVerifyCoverage?: () => boolean

	isHomeUse: boolean
	validateHomeUse?: () => boolean

	isPhonePlan: boolean
	validatePhonePlan?: () => boolean

	voipSelected: boolean
	keepNumber: boolean
	validateCurrentNumber?: () => boolean

	currentPhoneNumber1?: string
	currentPhoneNumber2?: string
	currentPhoneNumber3?: string
	currentPhoneNumber4?: string
	inboundCallNumber?: string
	validatePortabilityNumber?: () => boolean

	wifiCoverageCheck: boolean
	validateWifiCoverage?: () => boolean

	selectedOffer?: Offer
	offerChanged: boolean
	validateOffers?: () => boolean

	email?: string
	pec?: string
	phone?: string
	privacy: boolean
	validateEnterEmail?: () => boolean

	businessName?: string
	name?: string
	surname?: string
	gender: boolean
	foreignBirthPlace: boolean
	birthDate?: Date
	birthProvince?: string
	birthMunicipality?: string
	fiscalCode?: string
	vatNumber?: string
	sdi?: string
	provincesList?: string[]
	firstMunicipalitiesList?: string[]
	validateFirstDataPage?: () => boolean

	address?: string
	billingAddress?: string
	civicNumber?: string
	billingCivicNumber?: string
	cap?: string
	billingCap?: string
	common?: string
	province?: string
	billingProvince?: string
	billingMunicipality?: string
	secondMunicipalitiesList?: string[]
	capsList?: string[]
	validateSecondDataPage?: () => boolean

	options?: OptionSelection[]
	packageProducts: PlanOption[]
	planProducts: ExtendedPlanPair[]
	optionsEndReached: boolean
	validateOptionsView?: () => boolean

	paymentType?: PaymentType
	validatePaymentTypeView?: () => Promise<boolean>

	paymentMode?: PaymentMode
	validatePaymentModeView?: () => boolean

	iban?: string
	bank?: string
	place?: string
	validateBankPageView?: () => boolean

	documentType?: string
	documentNumber?: string
	documentExpiration?: Date
	validateDocumentsView?: () => Promise<boolean>
}

export let configuration: Configuration = {
	isCovered: false,

	isHomeUse: true,

	isPhonePlan: false,

	voipSelected: false,

	keepNumber: false,

	offerChanged: true,

	wifiCoverageCheck: false,

	privacy: false,

	gender: true,

	foreignBirthPlace: false,

	customerId: undefined,

	packageProducts: [],

	planProducts: [],

	documentType: DocumentType.IdentityCard,

	optionsEndReached: false
}

export let ConfiguratorContext = createContext<Configuration>(configuration)
